import { useMemo } from "react";

import { InfoCircle, WarningIcon } from "../../assets/icons";

import CustomTooltip from "../../common/styles/components/tooltip/CustomTooltip";

import { combineClassNames } from "../../utils/appUtils";

import "./DPFeedbackIconTooltip.scss";

export const FEEDBACK_TYPES = {
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
};

const DPFeedbackIconTooltip = ({
  type,
  message,
  placement,
  className,
  iconClassName,
  tooltipWidth = "260px",
  iconSize = 14,
  forceShow = false,
}) => {
  const Icon = useMemo(() => {
    switch (type) {
      case FEEDBACK_TYPES.WARNING:
        return WarningIcon;
      case FEEDBACK_TYPES.ERROR:
        return WarningIcon;
      case FEEDBACK_TYPES.INFO:
        return InfoCircle;
      default:
        return null;
    }
  }, [type]);

  if (!Icon || !message) return null;

  return (
    <CustomTooltip
      text={message}
      placement={placement}
      forceShow={forceShow}
      maxWidth={tooltipWidth}
      className={className}
    >
      <span
        className={combineClassNames(
          "dp-feedback-icon",
          `dp-feedback-icon--${type}`,
          className,
        )}
      >
        <Icon width={iconSize} height={iconSize} className={iconClassName} />
      </span>
    </CustomTooltip>
  );
};

export default DPFeedbackIconTooltip;
